import React from "react";
import Link from "gatsby-link";
import Section from "components/common/Section";

import JobPosting from "./assets/job_posting.jpg";
import HowRank from "./assets/how_you_rank.jpg";
import PlayMemories from "./assets/play_memories.jpg"
import GrowImage from "./assets/grow.jpg";
import JobPosting2x from "./assets/2x/job_posting.jpg";
import HowRank2x from "./assets/2x/how_you_rank.jpg";
import PlayMemories2x from "./assets/2x/play_memories.jpg"
import GrowImage2x from "./assets/2x/grow.jpg";

import "./PastProjectsSection.scss";

const ProjectSquare = ({ title, year, imageSrc, imageSrc2x, href, hoverTextCompany, hoverText, hoverYear }) => (
	<div className="projectSquare has-mobile-gutter">
		<Link className="projectLink" to={href}>
			<img className="projectImg" src={imageSrc} srcSet={`${imageSrc2x} 2x`} />
			<div className="hoverOverlay">
				<span className="overlayText subText">
					<span className="overlayCompany">
						{`${title}`}
					</span>
					{hoverYear}
				</span>
			</div>
		</Link>
	</div>
);

const CheckoutPage = () => (
	<ProjectSquare
		title="LinkedIn Job Posting Checkout Page"
		year="2015"
		imageSrc={JobPosting}
		imageSrc2x={JobPosting2x}
		hoverTextCompany="LinkedIn"
		href="/checkout"
		hoverYear="2015"
	/>
);

const HowYouRank = () => (
	<ProjectSquare
		title="LinkedIn How You Rank"
		year="2013 - 2014"
		imageSrc={HowRank}
		imageSrc2x={HowRank2x}
		hoverTextCompany="LinkedIn"
		href="/how-you-rank"
		hoverYear="2013 - 2014"
	/>
);

const Memories = () => (
	<ProjectSquare
		title="Sony Playmemories App"
		year="2011 - 2012"
		imageSrc={PlayMemories}
		imageSrc2x={PlayMemories2x}
		hoverTextCompany="Sony"
		href="/playmemories"
		hoverYear="2011 - 2012"
	/>
);

const Grow = () => (
	<ProjectSquare
		title="Grow Android Game"
		year="2010 - 2011"
		imageSrc={GrowImage}
		imageSrc2x={GrowImage2x}
		hoverTextCompany="EpicPixel"
		href="/grow"
		hoverYear="2010 - 2011"
	/>
);

export default () => (
	<Section className="pastProjectsSection  text-align-center" includeVerticalPadding={false}>
		<div className="font-size-large">
			Past projects I’ve worked on
		</div>
		<div className="pastProjectsGrid desktop-max-width-base">
			<CheckoutPage />
			<HowYouRank />
			<Memories />
			<Grow />
		</div>
	</Section>
);



// WEBPACK FOOTER //
// ./src/components/pages/index/PastProjectsSection.js